import PolicyList from './PolicyList';
import PolicyListItem from './PolicyListItem';
import PolicyListAddItem from './PolicyListAddItem';
import AddPolicyModal from './AddPolicyModal';
import RemovePolicyModal from './RemovePolicyModal';
import PolicyDetails from './PolicyDetails';
import EditPolicyModal from './EditPolicyModal';

const Policy = {};

Policy.List = PolicyList;
Policy.ListItem = PolicyListItem;
Policy.ItemAdd = PolicyListAddItem;
Policy.ModalAdd = AddPolicyModal;
Policy.ModalRemove = RemovePolicyModal;
Policy.ModalEdit = EditPolicyModal;
Policy.Details = PolicyDetails;

export default Policy;